<template>
  <div class="text-edit-inner-container">
    <div class="text-edit-inner"
      :style="{
        color: textColor,
        borderColor: textColor,
      }"
      contenteditable="true"
      placeholder="请输入内容..."
      ref="textValRef"
      @click.stop
      @input="inputFn"
      @blur="textBlurFn"
      @focus="textFocusFn"
    >
      
    </div>
    <el-scrollbar class="geo-info-container"
      max-height="12.5rem"
      @click.stop
      @mousewheel.stop
      v-if="geoInfoShowFlag && placeList.length > 0"
    >
      <div v-for="(place, index) of placeList"
        :key="index"
        @click.stop="placeClick(place)"
        class="geo-info-item"
      >
        {{place}}
      </div>
    </el-scrollbar>
    <el-color-picker
      @click.stop
      v-model="textColor"
      @change="colorChange"
      :style="{
        zIndex: 1,
      }"
    ></el-color-picker>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import store from '@/store';

import { getMapBoxPlaces, } from '@/api/MapManage';

// props
const props = defineProps({
  target: { type: Object, },
  layer: { type: Object, },
});
// emit
const emit = defineEmits([
  
]);
const customMarkerTypeProp = store.getters['leafletPolygon/customMarkerTypeProp'],
      customTextProp = store.getters['leafletPolygon/customTextProp'],
      customTextColorProp = store.getters['leafletPolygon/customTextColorProp'];

const roleName = localStorage.getItem('roleName');

const textColor = ref(props.target[customTextColorProp] || 'var(--fontColor_13)'), textValRef = ref();

const colorChange = (val)=>{
  props.target[customTextColorProp] = val;
}

const placeClick = (place)=>{
  // const pushStr = `${ place.place_name_zh || place.place_name } ${ place.center.join(',') }`;
  const pushStr = place;
  if(textValRef.value){
    textValRef.value.innerHTML = textValRef.value.innerHTML += pushStr;
  }
  props.target[customTextProp] = props.target[customTextProp] += pushStr;
}

const inputFn = (event)=>{
  const text = event.target.innerHTML || '';
  props.target[customTextProp] = text;
}
const geoInfoShowFlag = ref(false), geoInfoShowFlagChange = (flag)=>{
  geoInfoShowFlag.value = flag;
},
textFocusFn = ()=>{
  geoInfoShowFlagChange(true);
},
textBlurFn = ()=>{
  const timeEvent = setTimeout(()=>{
    geoInfoShowFlagChange(false);
    clearTimeout(timeEvent);
  }, 0.1 * 1000)
}

const textValRefFocus = ()=>{
  textValRef.value && textValRef.value.focus && textValRef.value.focus();
}

const placeList = ref([])
const getMapBoxPlacesFn = ()=>{
  if(roleName === '用户')return;
  const layer = props.layer;
  if(!layer)return;
  const { lat, lng } = layer.getLatLng();
  getMapBoxPlaces({
    latitude: lat,
    longitude: lng,
  }).then(res=>{
    if(res.data.code == 1004){
      placeList.value = JSON.parse(res.data.data);
      // if(res.data.data){
      //   const json = JSON.parse(res.data.data);
      //   placeList.value = json.features;
      // }
    }
  }).catch(err=>{
    console.log(err);
  });
}

const dataInit = ()=>{
  if(textValRef.value && props.target[customTextProp]){
    textValRef.value.innerHTML = props.target[customTextProp];
  }
  if(props.target[customTextColorProp]){
    textColor.value = props.target[customTextColorProp];
  }
}

const layerEventInit = ()=>{
  if(!props.layer)return;
  props.layer.on('dragend', ()=>{
    getMapBoxPlacesFn();
  })
},
layerEventClose = ()=>{
  if(!props.layer)return;
  props.layer.off('dragend')
}

const init = ()=>{
  dataInit();
  getMapBoxPlacesFn();
  layerEventInit();
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  init();
  nextTick(()=>{
    textValRefFocus();
    props.target[customMarkerTypeProp] = customTextProp;
  })
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  layerEventClose();
});

</script>

<style lang='less'>
// 文本编辑样式
.text-edit-inner-container{
  outline: none;
  border-radius: var(--borderRadiusSize);
  background: var(--backgroundColor_18);
  border: 2px solid var(--borderColor_8);
  box-shadow: 1px 2px 5px  var(--boxShadowColor_2);
  padding: 5px;
  .text-edit-inner{
    width: 180px;
    line-height: 24px;
    font-size: 16px;
    outline: none;
    padding: 0 5px;
    margin-bottom: 5px;
    &:focus{
      border: 1px dashed var(--borderColor_4);
    }
    &:empty:before{
      content: attr(placeholder);
      // color: var(--fontColor_10);
      color: var(--fontColor_13);
    }
  }
  .geo-info-container{
    position: absolute;
    // top: 0;
    z-index: 4;
    width: 100%;
    border-radius: var(--borderRadiusSize);
    padding: 5px;
    background-color: var(--backgroundColor_26);
    height: auto !important;
    :deep(.el-scrollbar__view){
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
      .geo-info-item{
        padding: 5px;
        border-radius: var(--borderRadiusSize);
        &:hover{
          background-color: var(--backgroundColor_29);
          color: var(--fontColor_13);
        }
      }
    }
  }
}
</style>

<style lang='less' scoped>
</style>